// oxlint-disable jsx-no-new-object-as-prop

import { EASE } from "@nnf3d/lib";
import type { GLOBAL_SETTINGS_QUERY_RESULT } from "@nnf3d/studio/types";
import type { PortableTextComponents } from "@portabletext/react";
import { PortableText } from "@portabletext/react";
import { useStore } from "@tanstack/react-store";
import { AnimatePresence, m } from "motion/react";

import { useGlobal } from "../lib/global-context";
import { loadStore, routeStore } from "../lib/store";
import type { VoidComponent } from "../lib/types";

const components = {
	block: {
		normal: ({ children, index }) => (
			<m.h1
				className="text-display-small xl:text-display-medium"
				initial={{ opacity: 0, y: "1rem" }}
				animate={{
					opacity: 1,
					y: "0",
					transition: { duration: 2, delay: 0.4 + index * 0.15, ease: EASE.OUT_EXPO },
				}}
				exit={{ opacity: 0, transition: { duration: 0.4, ease: EASE.OUT_CUBIC, delay: 0.1 } }}
			>
				{children}
			</m.h1>
		),
	},
	marks: { strong: ({ children }) => <span className="font-sans font-semibold">{children}</span> },
} as const satisfies PortableTextComponents<
	NonNullable<GLOBAL_SETTINGS_QUERY_RESULT[number]>["title"][number]
>;

const IndexRoute: VoidComponent = () => {
	const { title, description } = useGlobal();

	const level = useStore(routeStore, (state) => state.level);

	const { isStarted } = useStore(loadStore);

	return (
		<AnimatePresence>
			{isStarted && level === "index" && (
				<div className="fixed top-20 right-4 left-4 flex max-w-220 flex-col desktop:top-8 desktop:right-auto desktop:left-8">
					<PortableText value={title} components={components} />

					<m.p
						className="mt-2 max-w-[60ch] font-serif text-md desktop:mt-3"
						initial={{ opacity: 0, y: "1rem" }}
						animate={{
							opacity: 1,
							y: "0",
							transition: { duration: 2, delay: 0.7, ease: EASE.OUT_EXPO },
						}}
						exit={{ opacity: 0, transition: { duration: 0.4, ease: EASE.OUT_CUBIC } }}
					>
						{description}
					</m.p>
				</div>
			)}
		</AnimatePresence>
	);
};

export { IndexRoute };
